<template>
  <div class="w-full">
    <label class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">
      {{ label }}
    </label>
    <div class="flex">
      <div class="relative w-full">
        <div class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
          <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1M2 5h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm8 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
          </svg>
        </div>
        <input 
          :value="formattedValue"
          @input="formatNumberInput"
          @blur="onBlurNumberInput"
          @focus="onFocusNumberInput"
          type="text" 
          :id="inputId" 
          class="block h-11 p-2.5 w-full z-20 ps-10 text-base text-custom_gray bg-white rounded-s-lg border-e-gray-50 border-e-2 border border-gray-300 focus:ring-tuin_base-0 focus:border-tuin_base-0 dark:bg-gray-700 dark:border-e-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-tuin_base-0" 
          :placeholder="placeholder" 
          :required="required" 
        />
      </div>
      <div class="relative shrink-0">
        <button 
          :id="dropdownButtonId" 
          @click="toggleDropdown"
          class="h-11 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-custom_gray bg-gray-100 border border-gray-300 rounded-e-lg hover:bg-gray-200 focus:ring-2 focus:outline-none focus:ring-gray-100" 
          type="button"
        >
          <!-- Banderas de monedas -->
          <svg v-if="currency?.code === 'USD'" fill="none" aria-hidden="true" class="h-4 w-4 me-2" viewBox="0 0 20 15">
            <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
            <mask id="a" style="mask-type:luminance" width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse">
              <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
            </mask>
            <g mask="url(#a)">
              <path fill="#D02F44" fill-rule="evenodd" d="M19.6.5H0v.933h19.6V.5zm0 1.867H0V3.3h19.6v-.933zM0 4.233h19.6v.934H0v-.934zM19.6 6.1H0v.933h19.6V6.1zM0 7.967h19.6V8.9H0v-.933zm19.6 1.866H0v.934h19.6v-.934zM0 11.7h19.6v.933H0V11.7zm19.6 1.867H0v.933h19.6v-.933z" clip-rule="evenodd"/>
              <path fill="#46467F" d="M0 .5h8.4v6.533H0z"/>
            </g>
          </svg>
          <svg v-if="currency?.code === 'MXN'" xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none" class="h-4 w-4 me-2">
            <rect x="0.25" y="0.25" width="16.5" height="12.5" rx="1.75" fill="white" stroke="#F5F5F5" stroke-width="0.5"/>
            <mask id="mask0_4392_29205" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="13">
              <rect x="0.25" y="0.25" width="16.5" height="12.5" rx="1.75" fill="white" stroke="white" stroke-width="0.5"/>
            </mask>
            <g mask="url(#mask0_4392_29205)">
              <rect x="11.3335" width="5.66667" height="13" fill="#E3283E"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13H5.66667V0H0V13Z" fill="#128A60"/>
              <path d="M7.54753 6.06665C7.54753 5.69846 7.24905 5.39998 6.88086 5.39998C6.51267 5.39998 6.21419 5.69846 6.21419 6.06665H6.88086H7.54753ZM7.33675 8.13324C7.6495 8.32753 8.06054 8.23148 8.25483 7.91873C8.44911 7.60597 8.35307 7.19493 8.04031 7.00065L7.68853 7.56694L7.33675 8.13324ZM8.99442 6.97786C8.69062 7.18588 8.61297 7.60078 8.82099 7.90458C9.02901 8.20838 9.44391 8.28603 9.74771 8.07801L9.37107 7.52794L8.99442 6.97786ZM10.7856 6.06665C10.7856 5.69846 10.4871 5.39998 10.119 5.39998C9.75076 5.39998 9.45229 5.69846 9.45229 6.06665H10.119H10.7856ZM6.88086 6.06665H6.21419C6.21419 6.93301 6.65389 7.70906 7.33675 8.13324L7.68853 7.56694L8.04031 7.00065C7.75734 6.82487 7.54753 6.48181 7.54753 6.06665H6.88086ZM9.37107 7.52794L9.74771 8.07801C10.3818 7.64383 10.7856 6.8971 10.7856 6.06665H10.119H9.45229C9.45229 6.46409 9.25981 6.79615 8.99442 6.97786L9.37107 7.52794Z" fill="#8C9157"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49995 6.93337C8.94704 6.93337 9.30948 6.35134 9.30948 5.63337C9.30948 4.9154 8.94704 4.33337 8.49995 4.33337C8.05287 4.33337 7.69043 4.9154 7.69043 5.63337C7.69043 6.35134 8.05287 6.93337 8.49995 6.93337Z" fill="#C59262"/>
            </g>
          </svg>
          <svg v-if="currency?.code === 'EUR'" fill="none" aria-hidden="true" class="h-4 w-4 me-2" viewBox="0 0 20 15">
            <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
            <mask id="a" style="mask-type:luminance" width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse">
              <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
            </mask>
            <g mask="url(#a)">
              <path fill="#043CAE" d="M0 .5h19.6v14H0z"/>
              <path fill="#FFD429" fill-rule="evenodd" d="M9.14 3.493L9.8 3.3l.66.193-.193-.66.193-.66-.66.194-.66-.194.193.66-.193.66zm0 9.334l.66-.194.66.194-.193-.66.193-.66-.66.193-.66-.193.193.66-.193.66zm5.327-4.86l-.66.193L14 7.5l-.193-.66.66.193.66-.193-.194.66.194.66-.66-.193zm-9.994.193l.66-.193.66.193L5.6 7.5l.193-.66-.66.193-.66-.193.194.66-.194.66zm9.369-2.527l-.66.194.193-.66-.194-.66.66.193.66-.193-.193.66.193.66-.66-.194zm-8.743 4.86l.66-.193.66.193-.194-.66.194-.66-.66.194-.66-.194.193.66-.193.66zm7.034-6.568l-.66.193.194-.66-.194-.66.66.194.66-.193-.193.66.193.66-.66-.194zm-5.326 8.276l.66-.193.66.193-.194-.66.194-.66-.66.194-.66-.193.193.66-.193.66zM13.84 10.3l-.66.193.194-.66-.194-.66.66.194.66-.194-.193.66.193.66-.66-.193zM5.1 5.827l.66-.194.66.194-.194-.66.194-.66-.66.193-.66-.193.193.66-.193.66zm7.034 6.181l-.66.193.194-.66-.194-.66.66.194.66-.193-.193.66.193.66-.66-.194zm-5.326-7.89l.66-.193.66.193-.194-.66.194-.66-.66.194-.66-.193.193.66-.193.66z" clip-rule="evenodd"/>
            </g>
          </svg>
          {{ currency?.code || 'Moneda' }} 
          <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
          </svg>
        </button>
        <div 
          :id="dropdownId" 
          v-show="showDropdown"
          :class="dropdownClasses"
        >
          <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" :aria-labelledby="dropdownButtonId">
            <li v-for="option in currencyOptions" :key="resolveOption(option).code">
              <button 
                type="button" 
                @click="selectCurrency(resolveOption(option))"
                class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white" 
                role="menuitem"
              >
                <div class="inline-flex items-center">
                  <!-- Banderas en el dropdown -->
                  <svg v-if="resolveOption(option).code === 'USD'" fill="none" aria-hidden="true" class="h-4 w-4 me-2" viewBox="0 0 20 15">
                    <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
                    <mask id="a" style="mask-type:luminance" width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse">
                      <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
                    </mask>
                    <g mask="url(#a)">
                      <path fill="#D02F44" fill-rule="evenodd" d="M19.6.5H0v.933h19.6V.5zm0 1.867H0V3.3h19.6v-.933zM0 4.233h19.6v.934H0v-.934zM19.6 6.1H0v.933h19.6V6.1zM0 7.967h19.6V8.9H0v-.933zm19.6 1.866H0v.934h19.6v-.934zM0 11.7h19.6v.933H0V11.7zm19.6 1.867H0v.933h19.6v-.933z" clip-rule="evenodd"/>
                      <path fill="#46467F" d="M0 .5h8.4v6.533H0z"/>
                    </g>
                  </svg>
                  <svg v-if="resolveOption(option).code === 'MXN'" xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none" class="h-4 w-4 me-2">
                    <rect x="0.25" y="0.25" width="16.5" height="12.5" rx="1.75" fill="white" stroke="#F5F5F5" stroke-width="0.5"/>
                    <mask id="mask0_4392_29205" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="13">
                      <rect x="0.25" y="0.25" width="16.5" height="12.5" rx="1.75" fill="white" stroke="white" stroke-width="0.5"/>
                    </mask>
                    <g mask="url(#mask0_4392_29205)">
                      <rect x="11.3335" width="5.66667" height="13" fill="#E3283E"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13H5.66667V0H0V13Z" fill="#128A60"/>
                      <path d="M7.54753 6.06665C7.54753 5.69846 7.24905 5.39998 6.88086 5.39998C6.51267 5.39998 6.21419 5.69846 6.21419 6.06665H6.88086H7.54753ZM7.33675 8.13324C7.6495 8.32753 8.06054 8.23148 8.25483 7.91873C8.44911 7.60597 8.35307 7.19493 8.04031 7.00065L7.68853 7.56694L7.33675 8.13324ZM8.99442 6.97786C8.69062 7.18588 8.61297 7.60078 8.82099 7.90458C9.02901 8.20838 9.44391 8.28603 9.74771 8.07801L9.37107 7.52794L8.99442 6.97786ZM10.7856 6.06665C10.7856 5.69846 10.4871 5.39998 10.119 5.39998C9.75076 5.39998 9.45229 5.69846 9.45229 6.06665H10.119H10.7856ZM6.88086 6.06665H6.21419C6.21419 6.93301 6.65389 7.70906 7.33675 8.13324L7.68853 7.56694L8.04031 7.00065C7.75734 6.82487 7.54753 6.48181 7.54753 6.06665H6.88086ZM9.37107 7.52794L9.74771 8.07801C10.3818 7.64383 10.7856 6.8971 10.7856 6.06665H10.119H9.45229C9.45229 6.46409 9.25981 6.79615 8.99442 6.97786L9.37107 7.52794Z" fill="#8C9157"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49995 6.93337C8.94704 6.93337 9.30948 6.35134 9.30948 5.63337C9.30948 4.9154 8.94704 4.33337 8.49995 4.33337C8.05287 4.33337 7.69043 4.9154 7.69043 5.63337C7.69043 6.35134 8.05287 6.93337 8.49995 6.93337Z" fill="#C59262"/>
                    </g>
                  </svg>
                  <svg v-if="resolveOption(option).code === 'EUR'" fill="none" aria-hidden="true" class="h-4 w-4 me-2" viewBox="0 0 20 15">
                    <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
                    <mask id="a" style="mask-type:luminance" width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse">
                      <rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/>
                    </mask>
                    <g mask="url(#a)">
                      <path fill="#043CAE" d="M0 .5h19.6v14H0z"/>
                      <path fill="#FFD429" fill-rule="evenodd" d="M9.14 3.493L9.8 3.3l.66.193-.193-.66.193-.66-.66.194-.66-.194.193.66-.193.66zm0 9.334l.66-.194.66.194-.193-.66.193-.66-.66.193-.66-.193.193.66-.193.66zm5.327-4.86l-.66.193L14 7.5l-.193-.66.66.193.66-.193-.194.66.194.66-.66-.193zm-9.994.193l.66-.193.66.193L5.6 7.5l.193-.66-.66.193-.66-.193.194.66-.194.66zm9.369-2.527l-.66.194.193-.66-.194-.66.66.193.66-.193-.193.66.193.66-.66-.194zm-8.743 4.86l.66-.193.66.193-.194-.66.194-.66-.66.194-.66-.194.193.66-.193.66zm7.034-6.568l-.66.193.194-.66-.194-.66.66.194.66-.193-.193.66.193.66-.66-.194zm-5.326 8.276l.66-.193.66.193-.194-.66.194-.66-.66.194-.66-.193.193.66-.193.66zM13.84 10.3l-.66.193.194-.66-.194-.66.66.194.66-.194-.193.66.193.66-.66-.193zM5.1 5.827l.66-.194.66.194-.194-.66.194-.66-.66.193-.66-.193.193.66-.193.66zm7.034 6.181l-.66.193.194-.66-.194-.66.66.194.66-.193-.193.66.193.66-.66-.194zm-5.326-7.89l.66-.193.66.193-.194-.66.194-.66-.66.194-.66-.193.193.66-.193.66z" clip-rule="evenodd"/>
                    </g>
                  </svg>
                  {{ resolveOption(option).code }}
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  modelValue: {
    type: [String, Number],
    default: ''
  },
  currency: {
    type: Object,
    default: null
  },
  currencyOptions: {
    type: Array,
    default: () => []
  },
  inputId: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  dropdownAlign: {
    type: String,
    default: 'left', // 'left' or 'right'
    validator: (value) => ['left', 'right'].includes(value)
  }
})

const emit = defineEmits(['update:modelValue', 'update:currency'])

const showDropdown = ref(false)
const formattedValue = ref('')

// Number formatting functions (basado en FormCharactersComponent)
const formatNumber = (value) => {
  if (!value) return '';
  
  // Remove any existing commas and non-numeric characters except dots
  const numericValue = value.toString().replace(/[^\d.]/g, '');
  
  // Parse as float to handle decimals
  const num = parseFloat(numericValue);
  
  if (isNaN(num)) return '';
  
  // Format with commas and preserve up to 2 decimal places
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

const formatNumberInput = (event) => {
  const value = event.target.value;
  
  // Remove any non-numeric characters except dots and commas
  let cleanValue = value.replace(/[^\d.,]/g, '');
  
  // Remove existing commas for processing
  cleanValue = cleanValue.replace(/,/g, '');
  
  // Limit to 2 decimal places
  const parts = cleanValue.split('.');
  if (parts.length > 2) {
    cleanValue = parts[0] + '.' + parts[1];
  }
  if (parts[1] && parts[1].length > 2) {
    cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
  }
  
  // Update the formatted display value
  formattedValue.value = formatNumber(cleanValue);
  
  // Emit the clean numeric value
  const numericValue = parseFloat(cleanValue) || '';
  emit('update:modelValue', numericValue.toString());
};

const onFocusNumberInput = () => {
  // Show raw number when focused for easier editing
  formattedValue.value = props.modelValue ? props.modelValue.toString() : '';
};

const onBlurNumberInput = () => {
  // Format with commas when user leaves the field
  formattedValue.value = formatNumber(props.modelValue);
};

// Computed properties para IDs únicos
const dropdownId = computed(() => `dropdown-${props.inputId}`)
const dropdownButtonId = computed(() => `dropdown-${props.inputId}-button`)

// Computed para clases del dropdown basado en alineación
const dropdownClasses = computed(() => {
  const baseClasses = 'absolute top-full mt-2 z-10 bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-36 dark:bg-gray-700'
  if (props.dropdownAlign === 'right') {
    return `${baseClasses} right-0`
  }
  return `${baseClasses} left-0`
})

// Función para resolver la estructura de opciones (maneja tanto { value: {...} } como objetos directos)
function resolveOption(option) {
  return option.value || option
}

function toggleDropdown() {
  showDropdown.value = !showDropdown.value
}

function selectCurrency(selectedCurrency) {
  emit('update:currency', selectedCurrency)
  showDropdown.value = false
}

function onDocumentClick(event) {
  const dropdown = document.getElementById(dropdownId.value)
  const button = document.getElementById(dropdownButtonId.value)
  
  if (dropdown && button && !dropdown.contains(event.target) && !button.contains(event.target)) {
    showDropdown.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick)
  // Initialize formatted value
  formattedValue.value = formatNumber(props.modelValue)
})

onUnmounted(() => {
  document.removeEventListener('click', onDocumentClick)
})

// Watch for changes in modelValue to update formatted display
watch(() => props.modelValue, (newValue) => {
  formattedValue.value = formatNumber(newValue)
})
</script>